// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"5f6631578320f7b19ec3","147":"0c3014d911a1b0d46c31","251":"1227843f0cd0f9ddaf5b","265":"bdab3b8250d5ce5ad886","352":"7c1864c9c119706090ee"}[chunkId] + ".js";
};